"use client";
import { useEffect, useState } from "react";
import Link from "next/link";
import { usePathname } from "next/navigation";

type Me = { userId: string; role: "admin" | "manager" } | null;

type NavItem = { href: string; label: string; adminOnly?: boolean };

const NAV_ITEMS: ReadonlyArray<NavItem> = [
  { href: "/orders", label: "Продажи" },
  { href: "/fulfillment", label: "Заказы" },
  { href: "/counterparties", label: "Контрагенты" },
  { href: "/inventory", label: "Инвентаризация" },
  { href: "/receipts/new", label: "Приход" },
  { href: "/receipts/imports", label: "Приход из PDF" },
  { href: "/finance/payments", label: "Платежи" },
  { href: "/finance/accounts", label: "Кассы и счета" },
  { href: "/finance/dds", label: "ДДС" },
  { href: "/finance/settlements", label: "Взаиморасчёты" },
  { href: "/withdrawals", label: "Выплаты барберам" },
  { href: "/chat", label: "Чат" },
  { href: "/reports/stock", label: "Остатки" },
  { href: "/reconciliation", label: "Сверка 1С" },
  { href: "/audit", label: "Аудит" },
  { href: "/settings/organization", label: "Реквизиты", adminOnly: true },
  { href: "/directory/products", label: "Справочники", adminOnly: true },
];

export function AppNav() {
  const [me, setMe] = useState<Me>(null);
  const pathname = usePathname();
  useEffect(() => {
    fetch("/api/me").then((r) => (r.ok ? r.json() : null)).then((j) => setMe(j?.data ?? null));
  }, []);
  if (!me) return null;
  const isActive = (href: string) => {
    const p = pathname ?? "";
    return p === href || p.startsWith(href + "/");
  };
  return (
    <nav className="side" aria-label="Основная навигация">
      <div className="lg">Бриолин</div>
      <div className="nav">
        {NAV_ITEMS.filter((item) => !item.adminOnly || me.role === "admin").map((item) => {
          const active = isActive(item.href);
          return (
            <Link
              key={item.href}
              href={item.href}
              className={active ? "on" : undefined}
              aria-current={active ? "page" : undefined}
            >
              {item.label}
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
